module.exports = __webpack_public_path__ + "static/media/virgen-coromoto-small.c1af6235.jpg";